<template>
    <div class="p-4">
        <Carousel v-bind="settings">
            <Slide v-for="(slide, index) in slides" :key="index">
                <div class="carousel__item">
                    <img class="" :src="slide.url" alt="">
                </div>
            </Slide>
            <template #addons>
                <Pagination />
                <Navigation />
            </template>
        </Carousel>
    </div>
</template>

<script>
import 'vue3-carousel/dist/carousel.css'
import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel'
export default {
    name: "tab-1",
    components: {
      Carousel,
      Slide,
      Pagination,
      Navigation,
    },
    data() {
        return {
            settings: {
                itemsToShow: 1,
                snapAlign: 'center',
            },
            slides: [
                {
                    id: 1,
                    url: require('../../../assets/images/employment_report/fchs/FCHS_ER_2023-1.jpg'),
                },
                {
                    id: 2,
                    url: require('../../../assets/images/employment_report/fchs/FCHS_ER_2023-2.jpg'),
                },
                {
                    id: 3,
                    url: require('../../../assets/images/employment_report/fchs/FCHS_ER_2023-3.jpg'),
                },
                {
                    id: 4,
                    url: require('../../../assets/images/employment_report/fchs/FCHS_ER_2023-4.jpg'),
                },
                {
                    id: 5,
                    url: require('../../../assets/images/employment_report/fchs/FCHS_ER_2023-5.jpg'),
                },
                {
                    id: 6,
                    url: require('../../../assets/images/employment_report/fchs/FCHS_ER_2023-6.jpg'),
                },
                {
                    id: 7,
                    url: require('../../../assets/images/employment_report/fchs/FCHS_ER_2023-7.jpg'),
                },
                {
                    id: 8,
                    url: require('../../../assets/images/employment_report/fchs/FCHS_ER_2023-8.jpg'),
                },
                {
                    id: 9,
                    url: require('../../../assets/images/employment_report/fchs/FCHS_ER_2023-9.jpg'),
                },
            ]
        };
    },
}
</script>

